import { AnimatedBlob } from 'assets/icons'
import { bigEllipse, scoreMeter, smallEllipse } from 'assets/images/CreditScore'
import { scoringText, scoreColors } from 'constants/creditScore'
import { moneyFormat } from 'utils'
import EmojiSelector from './EmojiSelector'

// HEADER COMPONENTS

export const ScoreHeader = ({ score = 1 }: { score: number }) => (
  <HeaderContainer className='-mx-4 md:py-8' score={score}>
    <div className='md:flex md:items-center md:px-8 md:gap-24'>
      <div className='grid md:w-full grid-cols-1 grid-rows-1 justify-center items-center content-center justify-items-center'>
        <AnimatedBlob className='w-52 row-start-1 row-end-2 col-start-1 col-end-2 h-52 z-0' />
        <img
          src={smallEllipse}
          className='z-1 md:hidden row-start-1 row-end-2 col-start-1 col-end-2'
          alt='Emoji'
        />
        <img
          src={bigEllipse}
          className='z-1 max-h-[8.375rem] hidden md:block row-start-1 row-end-2 col-start-1 col-end-2'
          alt='Emoji'
        />
        <EmojiSelector score={score} />
      </div>
      <div className='md:mr-8 md:flex md:align-middle md:flex-col md:h-full md:justify-center'>
        <h2 className='font-bold text-2xl md:text-left'>
          {scoringText[score].title}
        </h2>
        <p className='text-xs font-normal mt-3 md:text-left'>
          {scoringText[score].paragraph}
        </p>
        {score >= 1 && score <= 4 && <ScoreMeter score={score} />}
      </div>
    </div>
  </HeaderContainer>
)

export const CapacityHeader = ({ score = 1 }: { score: number }) => (
  <HeaderContainer className='md:px-16 md:py-8 md:h-fit' score={score}>
    <p className='mt-5'>Tu capacidad de pago es: </p>
    <div className='max-w-32 grid grid-cols-1 grid-rows-1 justify-center items-center content-center justify-items-center'>
      <AnimatedBlob className='w-40 row-start-1 row-end-2 col-start-1 col-end-2 h-40 z-0' />
      <img
        src={smallEllipse}
        className='z-1 w-24 h-24 row-start-1 row-end-2 col-start-1 col-end-2'
        alt='Emoji'
      />
      <EmojiSelector className='h-[4.3rem] w-[4.3rem]' score={score} />
    </div>
    <h2 className='font-bold text-2xl'>{scoringText[score].title}</h2>
  </HeaderContainer>
)

// Revisar cómo va a venir el dato del update y su posible necesidad de parseo:
export const InstitutionsHeader = ({
  score = 1,
  amount = 455000,
  updateTime = '4 de julio'
}: {
  score: number
  amount: number
  updateTime: string
}) => (
  <HeaderContainer score={score}>
    <p className='mt-5'>Suma de compromisos vigentes</p>
    <div className='grid grid-cols-1 grid-rows-1 justify-center items-center content-center justify-items-center'>
      <AnimatedBlob className='w-[260px] max-w-screen row-start-1 row-end-2 col-start-1 col-end-2 h-[260px] z-0' />
      <img
        src={bigEllipse}
        className='z-1 row-start-1 row-end-2 col-start-1 col-end-2'
        alt='Emoji'
      />
      <p className='z-2 row-start-1 row-end-2 col-start-1 col-end-2 text-[1.75rem] font-bold'>
        {moneyFormat(amount)}
      </p>
    </div>
    <p className='text-xs'>
      Ultima actualización del Banco Central:{' '}
      <span className='font-bold'>{updateTime}</span>
    </p>
  </HeaderContainer>
)

// UTILITY COMPONENTS:
const ScoreMeter = ({ score = 1 }: { score: number }) => {
  const positionAndColorVariants = {
    1: 'col-start-4 col-end-5 bg-white',
    2: 'col-start-3 col-end-4 bg-black',
    3: 'col-start-2 col-end-3 bg-black',
    4: 'col-start-1 col-end-2 bg-white'
  }
  return (
    <div className='grid mx-auto md:mx-0 w-fit mt-6 grid-cols-4 grid-rows-2 gap-x-5 gap-y-1 justify-items-center'>
      <img className='col-start-1 col-end-5' src={scoreMeter} alt='' />
      <div
        className={`row-start-2 rounded-full h-[6px] w-[6px] row-end-3 ${positionAndColorVariants[score]}`}
      />
    </div>
  )
}

export const HeaderContainer = ({
  score,
  children,
  className
}: {
  score: number
  children: React.ReactNode
  className?: string
}) => (
  <div
    data-testid='headerContainer'
    className={`md:w-fit md:rounded-[30px] flex flex-col items-center rounded-b-xl -mt-4 text-center pt-2 pb-8 px-10 md:mt-0 md:mx-0 ${scoreColors[score]} ${className}`}
  >
    {children}
  </div>
)
